export const getPlatformType = () => {
  try {
    if (typeof window === "undefined") {
      return "Voopter Metasearch (desktop)";
    }

    const isMobileDevice =
      /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
        window.navigator.userAgent,
      ) || window.innerWidth < 768;

    return isMobileDevice
      ? "Voopter Metasearch (mobile)"
      : "Voopter Metasearch (desktop)";
  } catch (error) {
    console.warn("⚠️ Não foi possível identificar a plataforma:", error);
    return "Voopter Metasearch (desktop)";
  }
};
